import { useState, useCallback, useMemo, useEffect } from 'react'
import styled from '@emotion/styled'
import PrevIcon from '@mui/icons-material/NavigateBefore'
import NextIcon from '@mui/icons-material/NavigateNext'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { number, arrayOf, object, func } from 'prop-types'

const PullRight = styled.div`
  display: flex;
  flex-direction: row-reverse;
  padding: 4px;
  padding-top: 8px;
`

const PaddingTypography = styled(Typography)`
  padding-top: 6px;
`

const ButtonPadding = styled(Button)`
  margin-left: 4px;
  margin-right: 4px;
`

export const CvsPaginationFooter = ({ pageSize = 15, rows = [], onPageChange = () => {} }) => {
  const [page, setPage] = useState(1)
  const maxPage = useMemo(
    () => Math.floor(rows.length / pageSize) + (rows.length % pageSize === 0 ? 0 : 1),
    [rows, pageSize],
  )

  const movePage = useCallback(
    direction => {
      setPage(prev => {
        let newNumber = prev + direction
        if (newNumber < 1 || newNumber > maxPage) {
          newNumber = prev
        }
        return newNumber
      })
    },
    [setPage, maxPage],
  )

  useEffect(
    () => onPageChange(r => r.slice((page - 1) * pageSize, page * pageSize)),
    [onPageChange, page, pageSize, rows],
  )

  return rows.length > maxPage ? (
    <PullRight>
      <ButtonPadding margin="dense" size="small" onClick={() => movePage(1)}>
        <NextIcon data-test-page-id="next-page" />
      </ButtonPadding>
      <PaddingTypography variant="body2">{`${page} of ${maxPage}`}</PaddingTypography>
      <ButtonPadding margin="dense" size="small" onClick={() => movePage(-1)}>
        <PrevIcon data-test-page-id="previous-page" />
      </ButtonPadding>
    </PullRight>
  ) : null
}

CvsPaginationFooter.propTypes = {
  pageSize: number,
  rows: arrayOf(object),
  onPageChange: func,
}
